import { PlayerInfo } from "../models/PlayerInfo";
import { MAX_PLAYERS } from "../../config";
import GameInfo from "../models/GameInfo";
import moment from "moment";

const mapGameData = (gameData: any): GameInfo => {
  const data = new GameInfo(
    gameData.id,
    moment(gameData.DateStart),
    gameData.QuestionSet,
    loadPlayerInfo(gameData)
  );
  return data;
};

const loadPlayerInfo = (data: any) => {
  const players = [] as PlayerInfo[];
  for (let i = 1; i <= MAX_PLAYERS; i++) {
    const playerKey = `Player_${i}`;
    const playerId = data[playerKey];
    if (playerId) {
      players.push({
        id: playerId,
        name: data[`${playerKey}_DisplayName`],
        round: data[`${playerKey}_Round`] || 1,
        score: data[`${playerKey}_Score`]
      });
    }
  }
  return players;
};
export default mapGameData;

export { loadPlayerInfo };
